namespace TabAurous.Reports {
    export namespace StoneBifurcationService {
        export const baseUrl = 'Reports/StoneBifurcation';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<StoneBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetVouchers(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Common.Vouchers>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Reports/StoneBifurcation/List",
            GetVouchers = "Reports/StoneBifurcation/GetVouchers"
        }

        [
            'List', 
            'GetVouchers'
        ].forEach(x => {
            (<any>StoneBifurcationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
